import Image from "next/image";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

const ProfileAndDashboard = () => {
  const { t } = useTranslation("become-consultant");

  return (
    <section className="container lg:py-16">
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-20 justify-between items-start">
        <div className="relative flex-shrink-0">
          <Image src="/become-consultant/profile-dashboard.png" alt="Profile And Dashboard" width={661} height={587} />
          <div className="hidden lg:block absolute top-9 -right-4 translate-x-full">
            <div className="relative">
              <div className="absolute top-1/2 -left-2 border-t-4 border-r-8 border-b-4 border-solid -translate-y-1/2 border-t-transparent border-r-grey-300 border-b-transparent" />
              <div className="inline-block py-3.5 px-5 text-xs font-semibold bg-grey-300 rounded-lg">
                {t`profile-and-dashboard.your-user-account`}
              </div>
            </div>
          </div>
          <div className="hidden lg:block absolute right-32 bottom-40">
            <div className="relative">
              <div className="absolute top-1/2 -left-2 border-t-4 border-r-8 border-b-4 border-solid -translate-y-1/2 border-t-transparent border-r-grey-300 border-b-transparent" />
              <div className="inline-block py-3.5 px-5 text-xs font-semibold bg-grey-300 rounded-lg">
                {t`profile-and-dashboard.your-profile`}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 md:mt-16 lg:mt-24 xl:mt-32">
          <h2 className="text-xl lg:text-4xl font-semibold text-center lg:text-left">{t`profile-and-dashboard.title`}</h2>
          <p className="mt-3 text-xs lg:text-base text-center lg:text-left text-grey-700">
            {t`profile-and-dashboard.description`}
          </p>
          <Link href="/register/start" passHref>
            <button type="button" className="block mx-auto lg:mx-0 mt-5 lg:mt-12 button-lg hover-orange">
              {t`start-now`}
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProfileAndDashboard;
